export enum OrganizationSettingTypeEnum {
    COLLECTION_CATEGORY = 'collectionCategory',
    DARUJME = 'darujme',
    SPORITELNA = 'sporitelna',
    DONATION_FORM = 'donationForm',
    RAIFFEISEN = 'raiffeisen',
    WEB_GATEWAY = 'webGateway',
    PASSWORD_RESET = 'passwordReset',
    SYSTEM_SETTINGS = 'systemSettings',
    EMAILING_SETTINGS = 'emailingSettings',
    EMAIL_CLIENT_SETTINGS = 'emailClientSettings',
    MADO = 'mado',
    MADO_SETTINGS = 'madoSettings',
    MADO_CREDIT_AGREEMENTS = 'madoCreditAgreements',
    HEALTHCARE_SOCIAL_SETTINGS = 'healthCareSocialSettings',
    SOFTWARE602_SIGNING = 'software602Signing',
    TRASH_SETTINGS = 'trashSettings',
}
